export enum QtyTypeEnum {
	QTY = 'qty',
	PERCENT = 'percent',
	DOLLAR = 'dollar',
}
